import { render, staticRenderFns } from "./LaborDataDependent.vue?vue&type=template&id=2132e47e&scoped=true&"
import script from "./LaborDataDependent.vue?vue&type=script&lang=ts&"
export * from "./LaborDataDependent.vue?vue&type=script&lang=ts&"
import style0 from "./LaborDataDependent.vue?vue&type=style&index=0&id=2132e47e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2132e47e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCol,VForm,VRow,VTextField})
